import * as ContentActions from 'src/app/utility/actions/content.actions';
import {Content} from '../interfaces/content.interface';

export type Actions = ContentActions.Actions;

export function contentStateReducer(state: Content, action: Actions) {
  switch (action.type) {
    case ContentActions.SET_CONTENT:
      state = action.payload;
      return state;
    case ContentActions.DISMIS_CONTENT:
      state = null;
      return state;
    default:
      return state;
  }
}
